import React from "react";
import Layout from "../../Layout";

const LoyaltyWalletMainPage = () => {
  return (
    <Layout>
      <div className="text-text">LoyaltyWalletMainPage</div>
    </Layout>
  );
};

export default LoyaltyWalletMainPage;
